fragment FeaturedArticlesSlideFragment on featuredArticlesSlide_Entry {
  id
  typeHandle
  articles: featuredArticles {
    ... on featuredArticlesBlock_Entry {
      image {
        url
      }
      teaserText
      article {
        ... on article_Entry {
          title
          slug
          readTime
          image {
            url
          }
          topics(limit: 1) {
            title
            slug
            id
          }
          categories: knowledgeCategories(limit: 1) {
            title
            slug
            id
          }
        }
      }
    }
  }
}
